import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import LoadingScreen from "../LoadingScreen/LoadingScreen";

const PrivateRoute = ({ children, requiredRole }) => {
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const checkUserRole = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/auth/check-role`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch user role");

        const data = await response.json();
        setUserRole(data.role); // Assume your API returns the role in this format
      } catch (err) {
        console.error(err);
        setUserRole(null);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000); // Adjust timing as needed
      }
    };

    checkUserRole();
  }, [token]);

  // Loading state
  if (loading) {
    return <LoadingScreen />; // Show a loading state if needed
  }

  // Redirect based on role
  if (!token) {
    return <Navigate to="/get-started" />;
  }

  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to="/forbidden" />; // Redirect to forbidden page
  }

  return children; // Render the children if authorized
};

export default PrivateRoute;
